import {Component, EventEmitter, HostListener, Input, OnInit, Output, SecurityContext, ViewChild} from '@angular/core';
import {AccommodationService} from '../../../../../services/accommodation.service';
import {HelperService} from '../../../../../services/helper.service';
import {UserService} from '../../../../../services/user-services/user.service';
import {ActivatedRoute} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {FormsModule} from '@angular/forms';
import {MatChipsModule} from '@angular/material/chips';
import {NgClass, NgFor, NgIf} from '@angular/common';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-accommodation-city-input',
    templateUrl: './accommodation-city-input.component.html',
    styleUrls: ['./accommodation-city-input.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, MatChipsModule, FormsModule, NgxIntlTelInputModule, NgFor, IconComponent, TranslateModule]
})
export class AccommodationCityInputComponent implements OnInit {

  @Output() public hasChangedCity: EventEmitter<any> = new EventEmitter<any>();
  @Output() public hasSearched: EventEmitter<any> = new EventEmitter<any>();
  @Input() public searchElement = 'Lille';
  @Input() public showMatChip: boolean = false;
  @Input() public wantBtn: boolean = true;
  @Input() public currentSearchResult;
  @Input() public type: 'list' |'form-city' | 'form-school' = 'list';
  @Input() public placeholder:string = 'PROCESSES.ACCOMMODATION.ACCOMMODATION_SEARCH_PLACEHOLDER';

  public results = [];
  public cities = [];
  public schools = [];
  public open = false;
  public currentSearch = '';

  public isMobile: boolean = false;

  @ViewChild('result') private resultDiv;
  private _doSearchSub$;

  @HostListener('document:click', ['$event'])
  onClick(event) {
    if (this.resultDiv && this.resultDiv.nativeElement && !this.resultDiv.nativeElement.contains(event.target as Node)) {
      this.open = false;
    }
  }

  constructor(
    private accommodationService: AccommodationService,
    private helperService: HelperService,
    private userService: UserService,
    private route: ActivatedRoute,
  ) {
    if (this.route.snapshot.firstChild) {
      const input = this.route.snapshot.firstChild.paramMap.get('city');
      if(this.helperService.isValidInput(input) === true){
        this.searchElement = input
      }
      else {
        this.searchElement = 'Lille';
      }
    }
  }

  ngOnInit(): void {
    this.isMobile = this.userService.isMobileUser;
    if (this.searchElement) {
      this.showMatChip = true;
    }
  }

  public trigChangeCity(result?) {
    if (result && result.name && this.searchElement != this.helperService.slugify(result.name)) {
      this.searchElement = this.helperService.slugify(result.name);
      this.currentSearch = result.name;
      this.currentSearchResult = result;
      this.open = false;
      this.hasChangedCity.emit(result);

      // Capitalize for display
      const x = Array.from(this.searchElement)[0];
      this.searchElement = this.searchElement.replace(this.searchElement.charAt(0), x.toUpperCase());
      this.showMatChip = true;
      this.currentSearch = '';
    }
  }

  public colorResult(str: string): string {
    const k = this.currentSearch.trim();
    let name = this.helperService.removeAccent(k).replace(/\s+/gi, '-');
    const pattern = /\([^)]+\)/g;
    const match = str.match(pattern);

    if (match) {
      str = str.replace(/\([^)]+\)/g, '');
      let result = '';
      let index = 0;

      for (let i = 0; i < str.length; i++) {
        const char = str.substring(i, i + k.length).replace(/\([^)]+\)/g, '');
        const substring = this.helperService.removeAccent(char).replace(/\s+/gi, '-');

        if (substring.toLowerCase() === name.toLowerCase()) {
          result += '<span class="highlight">' + char + '</span>';
          index += k.length;
        } else {
          result += str.charAt(index);
          index++;
        }
      }

      result += '<span class="gray text_2">' + match + '</span>';
      return result.replace(/-/gi, ' ');
    } else {
      let result = '';
      let index = 0;

      for (let i = 0; i < str.length; i++) {
        const char = str.substring(i, i + k.length).replace(/\([^)]+\)/g, '');
        const substring = this.helperService.removeAccent(char).replace(/\s+/gi, '-');

        if (substring.toLowerCase() === name.toLowerCase()) {
          result += '<span class="highlight">' + char + '</span>';
          index += k.length;
        } else {
          result += str.charAt(index);
          index++;
        }
      }

      return result.replace(/-/gi, ' ');
    }
  }


  public eraseSearch(): void {
    this.currentSearchResult = null;
    this.currentSearch = '';
    this.cities = [];
    this.schools = [];
    this.open = false;
    this.showMatChip = false;
    if (this.type != 'list') {
      this.hasChangedCity.emit({name:null,id:null});
    }
  }

  public doSearch(event) {
    this.currentSearch = this.capitalizeFirstLetter(this.currentSearch);
    const search = event.target.value;
    this.hasSearched.emit(event);
    if (search.length >= 3) {
      this.currentSearch = search;
      if (event.key == 'Enter') {
        if (this.cities && this.cities[0]) {
          this.trigChangeCity(this.cities[0]);
        } else {
          if (this.type != 'list') {
            this.trigChangeCity({name: event.target.value});
          }
        }
      } else {
        if (this._doSearchSub$) {
          this._doSearchSub$.unsubscribe();
        }
        this._doSearchSub$ = this.accommodationService.getSearchElements(search).subscribe(data => {
          this.cities = data.cities;
          this.schools = data.schools;
          this.open = true;
        });
      }

    } else {
      this.open = false;
      this.cities = null;
      this.schools = null;
    }
  }

  public expandSearchZone() {
    this.userService.getCityorMetropoleById(this.currentSearchResult.cityGroup).subscribe(data => {
      this.searchElement = data;
      if (data.id == data.cityGroup || !data.cityGroup) {
        data.type = 'metropole';
      }
      this.trigChangeCity(this.searchElement);
    });
  }

  private capitalizeFirstLetter(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }


  public sendUnknownItem():void {
    if (this.type == 'form-school' && (this.schools.length == 0)) {
      this.trigChangeCity({name:this.currentSearch});
    }
  }
}
